import React from 'react';
import { validatePasswordStrength } from '../utils/auth';

const PasswordStrengthMeter = ({ password }) => {
  const { strength, strengthLabel, errors } = validatePasswordStrength(password);
  
  const colors = [
    'bg-red-500',
    'bg-red-400', 
    'bg-yellow-500',
    'bg-yellow-400',
    'bg-green-500',
    'bg-green-600'
  ];
  
  const textColors = [
    'text-red-600',
    'text-red-500',
    'text-yellow-600',
    'text-yellow-500',
    'text-green-600',
    'text-green-700'
  ];
  
  if (!password) return null;
  
  return (
    <div className="mt-2 space-y-2">
      {/* Strength Bar */}
      <div className="flex gap-1">
        {[0, 1, 2, 3, 4, 5].map((level) => (
          <div
            key={level}
            className={`h-1 flex-1 rounded-full transition-colors ${
              level <= strength ? colors[strength] : 'bg-gray-200'
            }`}
          />
        ))}
      </div>
      
      {/* Strength Label */}
      <p className={`text-sm font-medium ${textColors[strength]}`}>
        {strengthLabel}
      </p>
      
      {/* Requirements */}
      {errors.length > 0 && (
        <ul className="text-xs text-gray-600 space-y-1">
          {errors.map((error, index) => (
            <li key={index} className="flex items-start gap-1">
              <span className="text-red-500">✗</span>
              <span>{error}</span>
            </li>
          ))}
        </ul>
      )}
      
      {errors.length === 0 && (
        <p className="text-xs text-green-600 flex items-center gap-1">
          <span>✓</span>
          <span>Password meets all requirements</span>
        </p>
      )}
    </div>
  );
};

export default PasswordStrengthMeter;
